// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"25":"816c2a6a86107ccc","61":"e645bc4159466269","85":"1179683e976335c8","106":"713de9d051ff5933","239":"47388d49805a8fb1","336":"6cd826ba57847314","464":"97a81d20a2dff6a0","916":"fe3d224c1fff4c1a","941":"3c1c887fabaaf28e"}[chunkId] + ".js";
};